import getUrlParameters from './get.url.parameters';

export default function getClientId() {
    const defaultClientId = process.env.REACT_APP_DEFAULT_SSO_CLIENT_ID || 'mbp';
    const urlParameters = getUrlParameters();
    return urlParameters.client_id || defaultClientId;
}